<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Детали скидки
      <router-link class="btn btn-primary" :to="{ name: 'discount-edit', params: { id: discount.id }}">Редактировать информацию</router-link>
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'discounts' }">← Назад к Скидкам</router-link>
    </div>

    <div class="row">
      <div class="col-md-6">

        <!-- Name -->
        <div class="form-group">
          <label>Название</label>
          <p>{{ discount.name }}</p>
        </div>

        <!-- Amount -->
        <div class="form-group">
          <label>Сумма</label>
          <p>{{ toMoney(discount.amount) }}</p>
        </div>

        <!-- Start date -->
        <div class="form-group">
          <label>Дата начала</label>
          <p>{{ formatDate(discount.start_date) }}</p>
        </div>

        <!-- End date -->
        <div class="form-group">
          <label>Дата окончания</label>
          <p>{{ formatDate(discount.end_date) }}</p>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { getDiscount } from '@/services/discount.service'
import helpers from '@/helpers'

export default {
  name: 'discount-details',
  data () {
    return {
      discount: {
        id: null,
        name: '',
        amount: '',
        start_date: '',
        end_date: ''
      }
    }
  },
  mounted () {
    if (this.$route.params.id !== undefined) {
      this.discount.id = this.$route.params.id

      getDiscount(this.discount.id).then((response) => {
        this.discount = response.data
      })
    }
  },
  methods: {
    formatDate: helpers.formatDate,
    toMoney: helpers.toMoney
  }
}
</script>


// WEBPACK FOOTER //
// DiscountDetails.vue?46558d47